import { Box, Chip, Grid, Typography } from "@mui/material";
import BookingCompletionStage from "components/personal-rental/booking-completion-stage";
import BookingInfo from "components/personal-rental/booking-info";
import ListItem from "components/personal-rental/booking-item";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getPeronalRentalBookingDetails } from "slices/personalRentalReducer";
import { useAppDispatch, useAppSelector } from "store/appHooks";

const PersonalRentalDetailsPage = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const params = useParams();
  const { personalRentalReducer } = useAppSelector((state) => state);
  const { details }: any = personalRentalReducer;
  const bStatus = details?.booking_status;

  useEffect(() => {
    dispatch(getPeronalRentalBookingDetails({ id: Number(params.id) }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id]);

  const statusLabel = () => {
    let type = "";
    if ([1, 2].includes(bStatus)) {
      type = "requested";
    }
    if ([3].includes(bStatus)) {
      type = "confirmed";
    }
    if ([7, 9].includes(bStatus)) {
      type = "completed";
    }
    if ([6, 4].includes(bStatus)) {
      type = "cancelled";
    }
    if (type === "requested" && bStatus !== 2) return "Status: Pending";
    if (type === "requested" && bStatus === 2) return "Status: Pending Payment";
    if (type === "confirmed") return "Status: Confirmed";
    if (type === "completed")
      return bStatus === 7 ? "Status: Returned" : "Status: Delivered";
    if (type === "cancelled") return "Status: Cancelled";
    return "Status: Unknown";
  };

  const statusSxProps = () => {
    let type = "";
    if ([1, 2].includes(bStatus)) {
      type = "requested";
    }
    if ([3].includes(bStatus)) {
      type = "confirmed";
    }
    if ([7].includes(bStatus)) {
      type = "completed";
    }
    if ([6, 4].includes(bStatus)) {
      type = "cancelled";
    }
    if (type === "requested" && bStatus !== 2)
      return {
        background: "#FEF6E1",
        color: "#F1B724",
        fontSize: "13px",
        fontWeight: 500,
        lineHeight: "16px",
        width: "144px",
        height: "32px",
      };
    if (type === "requested" && bStatus === 2)
      return {
        background: "#FF3A441F",
        color: "#D21A00",
        fontSize: "13px",
        fontWeight: 500,
        lineHeight: "16px",
        width: "180px",
        height: "32px",
      };
    if (type === "confirmed")
      return {
        background: "#EFFFED",
        color: "#4EA643",
        fontSize: "13px",
        fontWeight: 500,
        lineHeight: "16px",
        width: "144px",
        height: "32px",
      };
    if (type === "completed")
      return {
        background: "#F4F4F4",
        color: "#323232",
        fontSize: "13px",
        fontWeight: 500,
        lineHeight: "16px",
        width: "144px",
        height: "32px",
      };
    if (type === "cancelled")
      return {
        background: "#FF3A441F",
        color: "#D21A00",
        fontSize: "13px",
        fontWeight: 500,
        lineHeight: "16px",
        width: "144px",
        height: "32px",
      };
  };

  return (
    <Box>
      <Box
        sx={{
          display: {
            md: "flex",
            lg: "flex",
            xl: "flex",
            sm: "flex",
            xs: "flex",
          },
          px: "4%",
          py: "20px",
          borderBottom: "1px solid #F4F4F4",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "15px",
            flex: 2,
          }}
        >
          <img
            src="/assets/img/icons/arrow_left.svg"
            alt=""
            width="24px"
            height="24px"
            onClick={() => navigate(-1)}
          />
          <Typography
            sx={{
              color: "#323232",
              fontWeight: 600,
              fontSize: "24px",
              lineHeight: "35px",
            }}
          >
            Booking Details
          </Typography>
        </Box>
      </Box>

      <Box sx={{ postion: "relative" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            my: "20px",
            px: "4%",
            position: "relative",
            //   borderBottom: "1px solid #E2E2E2",
          }}
        >
          {details?.booking_items?.map((item: any, index: number) => (
            <ListItem
              data={item}
              isLast={index + 1 === details?.booking_items?.length}
              details={details}
            />
          ))}
          {bStatus !== 6 && (
            <Box
              sx={{
                position: "absolute",
                top: 0,
                right: "4%",
                display: {
                  sm: "none",
                  xs: "none",
                  md: "flex",
                  lg: "flex",
                  xl: "flex",
                },
              }}
            >
              <Chip label={statusLabel()} sx={statusSxProps()} />
            </Box>
          )}
        </Box>
      </Box>
      <Box sx={{ px: "4%", my: "15px" }}>
        <Grid container>
          <Grid item md={6} lg={6} xl={6} sm={12} xs={12}>
            <BookingCompletionStage />
          </Grid>
          <Grid item md={6} lg={6} xl={6} sm={12} xs={12}>
            <BookingInfo />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default PersonalRentalDetailsPage;
